// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.nav-bottom {\n  transition: transform 0.3s ease-in-out;\n}\n.nav-bottom.hidden {\n  transform: translateY(100%);\n}\n", ""]);
// Exports
module.exports = exports;
